import React, { Component } from "react";
import { Modal, ModalBody, ModalHeader, Tooltip } from 'reactstrap';
import { qrCodeProxyURLStory } from "../../lib/data";
import QRCode from 'react-qr-code';


export default class QRModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      tooltipOpen: false,
    }

    this.toggleModal = this.toggleModal.bind(this);
    this.toggleTooltipOpen = this.toggleTooltipOpen.bind(this);
  }

  toggleModal() {
    this.setState(prevState => ({
      modal: !prevState.modal
    }))
  }

  toggleTooltipOpen() {
    this.setState(prevState => ({
      tooltipOpen: !prevState.tooltipOpen
    }));
  }

  render() {
    const { user, storyId } = this.props;
    const { tooltipOpen } = this.state;
    return <div>
      <span className="ar-icon s7-diamond pt-2" onClick={this.toggleModal} id={`storyAccessLink${storyId}`} />
      <Tooltip isOpen={tooltipOpen} target={`storyAccessLink${storyId}`}
        toggle={this.toggleTooltipOpen}>
        Show QR
      </Tooltip>
      <Modal isOpen={this.state.modal} toggle={this.toggleModal} className={`modal-s ${user.role === 3 ? "superadmin" : ""}`}>
        <ModalHeader>
          <span onClick={this.toggleModal} className="s7-close modal-close" />
        </ModalHeader>
        <ModalBody className="pt-0">
          <div className="row xs-gutters">
            <div className="col-12 text-center">
              <h3>Story</h3>
            </div>
            <div className="col-12 text-center mt-3">
              <p>Please scan this QR code with your mobile device camera to open the IndexAR app and preview your story:</p>
            </div>
            <div className="col-12 text-center mt-5 text-center">
              <QRCode value={qrCodeProxyURLStory + storyId} />
            </div>
            <div className="col-12 text-center text-center p-5">
              <a href={qrCodeProxyURLStory + storyId} target="_blank" rel="noreferrer noopener">
                {qrCodeProxyURLStory + storyId}
              </a>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/components/Story/QRModal.js